import { useEffect, useState } from 'react';
import './ShopBasket.css'
import { Link, useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { HiOutlineTrash } from "react-icons/hi2";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import config from '../../../config';
import StoreBanner from '../Shop/StoreBanner';
import { useTelegram } from '../../../hooks/auth/useTelegram';
import TelegramSafeArea from '../../../Components/TelegramSafeArea';

const toFa = (value) => {
    if (value === null || value === undefined) return '';
    return value.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
};

const toFaPrice = (num) => {
    return Number(num || 0).toLocaleString('fa-IR');
};

const themeColors = [
    { id: 1, title: "قرمز", code: "#D32F2F", text: "#000" },
    { id: 2, title: "سبز", code: "#388E3C", text: "#000" },
    { id: 3, title: "زرد", code: "#FBC02D", text: "#000" },
    { id: 4, title: "صورتی", code: "#C2185B", text: "#000" },
    { id: 5, title: "آبی", code: "#1976D2", text: "#000" },
    { id: 6, title: "بنفش", code: "#7B1FA2", text: "#000" },
    { id: 7, title: "نارنجی", code: "#E64A19", text: "#000" },
    { id: 8, title: "طوسی", code: "#212121", text: "#000" },
];

const isDummyName = (name) => {
    if (!name) return true;
    const n = String(name).trim();
    const dummies = ['', '-', '_', 'پیش فرض', 'بدون ویژگی', 'بدون متغیر', 'عادی', 'نامشخص', 'نام خصوصیت اول', 'نام خصوصیت دوم', 'کالای اصلی', 'null', 'undefined'];
    return dummies.includes(n);
};

function ShopBasket() {
    const navigate = useNavigate();

    const [store, setStore] = useState(JSON.parse(sessionStorage.getItem("store")) ?? null);

    const [cartItems, setCartItems] = useState(
        (JSON.parse(localStorage.getItem("baskets")) ?? [])
            .find((x) => Number(x.id) === Number(store?.id))?.cartItems ?? []
    );

    const [backgroundcolor, setBackgroundcolor] = useState(null);
    const [color, setColor] = useState(null);
    const [bgLight, setBgLight] = useState(null);

    const { ChatId, params } = useTelegram();

    useEffect(() => {
        if (!store || cartItems.length === 0) {
            navigate("/Shop", { replace: true });
        }
    }, [store, cartItems, navigate]);

    useEffect(() => {
        if (store) {
            if (store.theme_json) {
                try {
                    const themeData = typeof store.theme_json === 'string' ? JSON.parse(store.theme_json) : store.theme_json;
                    const colorId = themeData?.color_id;

                    const selectedColor = themeColors.find(c => c.id === Number(colorId));

                    if (selectedColor) {
                        setBackgroundcolor(selectedColor.code);
                        setColor(selectedColor.text);
                        setBgLight(`${selectedColor.code}1A`);
                    }
                } catch (error) {
                    console.error("خطا در پارس theme_json", error);
                }
            }
        }
    }, [store])


    useEffect(() => {
        if (store && cartItems) {
            const allBaskets = JSON.parse(localStorage.getItem("baskets")) ?? [];
            const storeIndex = allBaskets.findIndex(x => Number(x.id) === Number(store.id));

            if (storeIndex !== -1) {
                allBaskets[storeIndex].cartItems = cartItems;
                localStorage.setItem("baskets", JSON.stringify(allBaskets));
            }
        }
    }, [cartItems, store]);


    const isSameItem = (item1, item2) => {
        return item1.id === item2.id && item1.variant_id === item2.variant_id;
    };


    const onAdd = (product) => {
        const exist = cartItems.find((x) => isSameItem(x, product));

        if (exist) {
            let currentStock = null;

            if (product.properties) {
                try {
                    const parsedProps = typeof product.properties === 'string' ? JSON.parse(product.properties) : product.properties;
                    if (product.p1Name && parsedProps?.propertyData && parsedProps.propertyData[product.p1Name]) {
                        const variant = parsedProps.propertyData[product.p1Name].find(v => v.id === product.variant_id);
                        if (variant && variant.stock !== undefined) {
                            currentStock = variant.stock;
                        }
                    }
                } catch (error) {
                    console.error("خطا در خواندن موجودی", error);
                }
            }

            if (currentStock !== null && Number(exist.quantity) >= Number(currentStock)) {
                toast.error(`حداکثر موجودی این کالا در انبار (${currentStock} عدد) در سبد شماست!`);
                return;
            }

            setCartItems(
                cartItems.map((x) =>
                    isSameItem(x, product) ? {
                        ...exist,
                        quantity: Number(exist.quantity) + 1,
                        totalPrice: exist.price * (Number(exist.quantity) + 1),
                        totalPrice2: (exist.price - (exist.discount_price || 0)) * (Number(exist.quantity) + 1),
                        invoicePrice: ((exist.price - (exist.discount_price || 0)) + (exist.vat_price || 0) + (exist.pack_cost || 0)) * (Number(exist.quantity) + 1),
                    } : x
                )
            );
        }
    };

    const onRemove = (product) => {
        const exist = cartItems.find((x) => isSameItem(x, product));
        if (exist.quantity === 1) {
            setCartItems(cartItems.filter(x => !isSameItem(x, product)));
        } else {
            setCartItems(
                cartItems.map(x =>
                    isSameItem(x, product) ? {
                        ...exist,
                        quantity: exist.quantity - 1,
                        totalPrice: exist.price * (exist.quantity - 1),
                        totalPrice2: (exist.price - exist.discount_price) * (exist.quantity - 1),
                        invoicePrice: ((exist.price - exist.discount_price) + exist.vat_price + exist.pack_cost) * (exist.quantity - 1),
                    } : x
                )
            )
        }
    }

    const onDelete = (product) => {
        setCartItems(cartItems.filter(x => !isSameItem(x, product)))
    }

    const handleExitBasket = () => {
        if (store?.id) {
            sessionStorage.removeItem(`delivery_state_${store.id}`);
        }
    };

    if (!store || cartItems.length === 0) return null;

    return (
        <div className='shop-basket' style={{ backgroundColor: bgLight || '#F9F9F9', minHeight: '100vh' }}>

            <div className="topbar">
                <TelegramSafeArea style={{ background: "transparent", color: "#000" }}>
                    <div
                        className="safe-area-title"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: '1.3'
                        }}
                    >
                        {store?.title ? (
                            <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{store.title}</span>
                        ) : (
                            <div className="skeleton-shimmer" style={{ width: '80px', height: '14px', borderRadius: '4px', marginBottom: '4px' }}></div>
                        )}

                        {store?.message ? (
                            <span style={{ fontSize: '12px', opacity: 0.85 }}>{store.message}</span>
                        ) : store ? null : (
                            <div className="skeleton-shimmer" style={{ width: '120px', height: '10px', borderRadius: '4px' }}></div>
                        )}
                    </div>
                </TelegramSafeArea>

                <StoreBanner store={store} />
                <div className="header" style={{ color: color, background: "transparent" }}>
                    <div className="title">سبد خرید</div>
                    <Link to="/Shop" onClick={handleExitBasket}>
                        <div className="back">
                            <div className="btn-back"><IoMdArrowRoundBack size={"25px"} /></div>
                        </div>
                    </Link>
                </div>
            </div>

            <div className="body-shop">
                <div className="wrraper-shop">
                    {cartItems && cartItems.map((commodity, index) => {

                        // ساخت عنوان ویژگی با حذف مقادیر بی معنی
                        let features = [];
                        if (!isDummyName(commodity.p1Name)) features.push(commodity.p1Name);
                        if (!isDummyName(commodity.name) && commodity.name !== commodity.p1Name) features.push(commodity.name);

                        let variantTitle = "";
                        if (features.length > 0) {
                            variantTitle = features.join(" - ");
                        } else {
                            if (!isDummyName(commodity.variant_title)) {
                                variantTitle = commodity.variant_title;
                            } else if (!isDummyName(commodity.extraTitle)) {
                                variantTitle = commodity.extraTitle;
                            }
                        }

                        return (
                            <div className="commodity-basket" key={`${commodity.id}-${commodity.variant_id || index}`}>
                                <div className="commodity-right">
                                    <img src={`${config.api.imageURL}/${commodity.image_path}`} alt={"کالا"} />
                                </div>
                                <div className="commodity-left">
                                    <div className="commodity-title"><span>{commodity.title}</span></div>

                                    {/* نمایش بخش ویژگی فقط در صورتی که دیتای معتبری وجود داشته باشد */}
                                    {variantTitle && (
                                        <div className="commodity-description"><span>{variantTitle}</span></div>
                                    )}

                                    <div className="commodity-price"><span>
                                        {toFaPrice(commodity.price - (commodity.discount_price || 0))} تومان
                                    </span></div>
                                    <div className="delete" onClick={() => onDelete(commodity)}><HiOutlineTrash color="red" size='1.4em' /></div>
                                    <div className="amount-wrraper">
                                        <div className='btn-amount increment' onClick={() => onAdd(commodity)}><FaAngleUp /></div>
                                        <div className='digit'>
                                            {toFa(commodity.quantity ?? 0)}
                                        </div>
                                        <div className='btn-amount decrement' onClick={() => onRemove(commodity)}><FaAngleDown /></div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    <Link to="/ShopDelivery">
                        <div className="btn_confirm-and-continue" style={{ backgroundColor: backgroundcolor }}>
                            <div>
                                <span>تایید و ادامه</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ShopBasket;
